/* eslint-disable react/prop-types */
import {
  Box,
  Button,
  Divider,
  Grid,
  Tab,
  Tabs,
  Typography,
  Link,
} from "@mui/material";
import BusinessIcon from "@mui/icons-material/Business";
import ArticleIcon from "@mui/icons-material/Article";
import { useEffect, useState } from "react";
import { JsonTool } from "utils/jsonTools";
import CustomTabPanel from "components/CustomPanel/customPanel";
import EditIcon from "@mui/icons-material/Edit";
import { API_URL_DOWNLOAD, checkUrlTep } from "../../utils/constants";
import { DownloadIcon } from "@primer/octicons-react";

export default function DetailChuTheOCOP({ data, fieldInfor, onEdit }) {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    return () => {
      setValue(0);
    };
  }, []);

  const handleToEditDetail = () => {
    onEdit?.();
  };
  return (
    <Box bgcolor={"#ffffff"} borderRadius={"1rem"} marginBottom={"2rem"}>
      <Box sx={{ maxWidth: "1000px", margin: "auto" }}>
        <Box
          sx={{ display: "flex", width: "100%", justifyContent: "flex-end" }}
        >
          <Button
            variant="contained"
            sx={{ color: "#ffffff", margin: "1rem 1rem 0 1rem" }}
            startIcon={<EditIcon />}
            size="medium"
            onClick={handleToEditDetail}
          >
            Chỉnh sửa
          </Button>
        </Box>
        <Box
          sx={{
            width: "100%",
            bgcolor: "background.paper",
            borderColor: "divider",
            padding: "1rem 1rem 0 1rem",
          }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="secondary"
            textColor="primary"
            variant="fullWidth"
          >
            <Tab
              icon={<BusinessIcon />}
              label="Thông tin"
              {...JsonTool.a11yProps(0)}
            />
            <Tab
              icon={<ArticleIcon />}
              label="Tệp đính kèm"
              {...JsonTool.a11yProps(1)}
            />
          </Tabs>
        </Box>
        <Divider />
        <CustomTabPanel value={value} index={0}>
          <Grid
            container
            spacing={1}
            border={"2px solid #d6d6d6"}
            sx={{ borderRadius: "0.5rem" }}
          >
            {fieldInfor &&
              fieldInfor.length > 0 &&
              fieldInfor.map((item) => (
                <Grid
                  item
                  xs={item?.xs}
                  md={item?.md}
                  lg={item?.lg}
                  key={item?.key + "inforField"}
                  sx={{
                    borderBottom: "1px solid #d6d6d6",
                    borderRight: "1px solid #d6d6d6",
                  }}
                >
                  <Typography fontSize={"0.75rem"} fontWeight={"500"}>
                    {item?.name}:
                  </Typography>
                  <Typography fontSize={"1rem"}>
                    {data?.[item?.key]
                      ? data?.[item?.key]
                      : "Đang cập nhập ..."}
                  </Typography>
                </Grid>
              ))}
          </Grid>
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          {data &&
            data.id &&
            (data.tepdinhkem_chuthe && data.tepdinhkem_chuthe?.length > 0 ? (
              <Grid container p="0 1rem 1rem 1rem">
                <Grid
                  container
                  style={{
                    color: "#000000",
                    backgroundColor: "rgb(142 199 243)",
                  }}
                  fontSize={"1rem"}
                  fontWeight={600}
                  pb={"0.5rem"}
                  m={"0.5rem 0"}
                  spacing={1}
                  borderBottom={"2px solid #3F51B5"}
                >
                  <Grid item xs={2}>
                    STT
                  </Grid>
                  <Grid item xs={8}>
                    Tên tệp đính kèm
                  </Grid>
                  <Grid item xs={2}>
                    Tải về
                  </Grid>
                </Grid>
                {data.tepdinhkem_chuthe?.map((tep, index) => (
                  <Grid
                    container
                    key={tep?.id + index}
                    style={{ color: "#000000" }}
                    fontSize={"1rem"}
                    borderBottom={"1px solid #d6d6d6"}
                    pb={"0.5rem"}
                    mb={"0.5rem"}
                    ml={0}
                    spacing={1}
                  >
                    <Grid item xs={2}>
                      {index + 1}
                    </Grid>
                    <Grid item xs={8}>
                      {tep?.tentepdinhkem}
                    </Grid>
                    <Grid
                      item
                      xs={2}
                      display={"flex"}
                      alignItems={"center"}
                      justifyContent={"center"}
                      style={{ paddingTop: "0px" }}
                    >
                      <Typography variant="h5" color="info">
                        <Link
                          target="_blank"
                          href={API_URL_DOWNLOAD + checkUrlTep(tep?.tepdinhkem)}
                        >
                          <DownloadIcon />
                        </Link>
                      </Typography>
                    </Grid>
                  </Grid>
                ))}
              </Grid>
            ) : (
              <Grid
                container
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                p="1rem"
                height="100%"
              >
                <Typography
                  style={{
                    fontSize: "1.25rem",
                    fontWeight: "500",
                    lineHeight: "1.5rem",
                    color: "black",
                  }}
                >
                  Không có thông tin Tệp đính kèm
                </Typography>
              </Grid>
            ))}
        </CustomTabPanel>
      </Box>
    </Box>
  );
}
